import { render, staticRenderFns } from "./CardSlider.vue?vue&type=template&id=752cc3ae&scoped=true&"
import script from "./CardSlider.vue?vue&type=script&lang=js&"
export * from "./CardSlider.vue?vue&type=script&lang=js&"
import style0 from "./CardSlider.vue?vue&type=style&index=0&id=752cc3ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "752cc3ae",
  null
  
)

export default component.exports